export function showPlatform(ownProps, query) {
  const { boardType, is_show_app, is_show_mobile, is_show_pc } = ownProps;

  if (query === null || query === undefined) {
    return query;
  }

  let newQuery = { ...query };
  if (boardType === 'NoticeBoard') {
    if (is_show_app === true) {
      newQuery['is_show_app'] = is_show_app;
    }
    if (is_show_mobile === true) {
      newQuery['is_show_mobile'] = is_show_mobile;
    }
    if (is_show_pc === true) {
      newQuery['is_show_pc'] = is_show_pc;
    }
  }
  return newQuery;
}
